import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SignedUrlObject } from '@shared/models/signedUrlObject.model';
import { BaseService } from '@shared/services/base.service';
import { Observable, map } from 'rxjs';

import {
  StoreExpenseCancelRequest,
  StoreExpenseRequestSearchCriteria,
  StoreExpenseViewResponse,
  SubmitStoreExpenseRequest
} from '../models/store-expense.model';

@Injectable({
  providedIn: 'root'
})
export class StoreExpenseService extends BaseService {
  public override headers: HttpHeaders;
  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.storeExpense;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getStoreExpenseRemain(): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.remaining, {
      storeNo
    });

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body'
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getStoreExpenseRequestList(criteria: StoreExpenseRequestSearchCriteria): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.list, {
      storeNo
    });
    const params = this.getParams(criteria);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getStoreExpenseView(docNo): Observable<StoreExpenseViewResponse> {
    const url = this.getFullUrlWithStoreNo(this.envService.view, docNo);

    return this.http.get<StoreExpenseViewResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  override getFileUrl(refId: string): Observable<SignedUrlObject> {
    const url = this.getFullUrlWithStoreNo(this.envService.fileUrl);
    return this.http.post<SignedUrlObject>(url, { refId }, { headers: this.headers });
  }

  submitEvidence(request: SubmitStoreExpenseRequest): Observable<any> {
    const url = this.getFullUrlWithStoreNo(this.envService.submitEvidence);
    const formData = new FormData();

    for (const key in request) {
      if (request.hasOwnProperty(key)) {
        formData.append(key, request[key]);
      }
    }
    return this.http.post<any>(url, formData, {
      headers: this.loaderHeaders(),
      observe: 'body',
      responseType: 'json'
    });
  }

  submitSendBackEvidence(request: SubmitStoreExpenseRequest): Observable<any> {
    const url = this.getFullUrlWithStoreNo(this.envService.submitSendBackEvidence);
    const formData = new FormData();

    for (const key in request) {
      if (request.hasOwnProperty(key)) {
        formData.append(key, request[key]);
      }
    }
    return this.http.post<any>(url, formData, {
      headers: this.loaderHeaders(),
      observe: 'body',
      responseType: 'json'
    });
  }

  public history(docNo: any): Observable<any> {
    const url = this.getFullUrlWithStoreNo(this.envService.history, { docNo });

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body'
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  cancel(request: StoreExpenseCancelRequest): Observable<any> {
    const url = this.getFullUrlWithStoreNo(this.envService.cancel, { docNo: request.docNo });
    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(3000),
      observe: 'body',
      responseType: 'json'
    });
  }
}
